<template>
  <div>
    <div style="text-align: right;">
      <span
        style="float: left; margin-top: 5px;"
        class="ant-descriptions-title"
      >
        Annual Leave Information
      </span>
      <a-button icon="edit" type="link" @click="() => (visibleEdit = true)">
      </a-button>
    </div>
    <a-descriptions :column="1">
      <a-descriptions-item
        label="Total working hour in day / Tổng số giờ làm việc của ca"
      >
        {{ employeeShift.duration }}
      </a-descriptions-item>
      <a-descriptions-item label="Original / Ngày nghỉ phép năm ban đầu">
        <span v-if="employee.annualLeaveDay">
          {{
            (+employee.annualLeaveDay.original / +employeeShift.duration)
              | numParseFloat(2)
          }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item
        label="Total day annual leave/ Tổng số ngày nghỉ phép năm"
      >
        <span v-if="employee.annualLeaveDay">
          {{
            (+employee.annualLeaveDay.default / +employeeShift.duration)
              | numParseFloat(2)
          }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item
        label="Total hour annual leave / Tổng số giờ nghỉ phép năm"
      >
        <span v-if="employee.annualLeaveDay">
          {{
            (+employee.annualLeaveDay.default )

          }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item
        label="Total day annual leave remain / Số ngày nghỉ phép còn lại"
      >
        <span v-if="employee.annualLeaveDay">
          {{
            (+employee.annualLeaveDay.remain / +employeeShift.duration)
              | numParseFloat(2)
          }}
        </span>
      </a-descriptions-item>

      <a-descriptions-item
        label="Total hour annual leave remain / Số giờ nghỉ phép còn lại"
      >
        <span v-if="employee.annualLeaveDay">
          {{ +employee.annualLeaveDay.remain }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item
        label="Total day annual leave used / Số ngày nghỉ phép đã sử dụng"
      >
        <span v-if="employee.annualLeaveDay">
          {{
            (+employee.annualLeaveDay.usedInYear / +employeeShift.duration ||
              0) | numParseFloat(2)
          }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item
        label="Total hour annual leave used / Số giờ nghỉ phép đã sử dụng"
      >
        <span v-if="employee.annualLeaveDay">
          {{ (+employee.annualLeaveDay.usedInYear || 0) | numParseFloat(2) }}
        </span>
      </a-descriptions-item>
    </a-descriptions>
    <a-drawer
      :width="450"
      title="Edit annual leave"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100% - 100px)' }"
    >
      <EditLeaveDay
        :annualLeaveDay="employee.annualLeaveDay || {}"
        :close="() => (visibleEdit = false)"
        :refreshEmployeeAfterLeaveAnualUpdated="
          refreshEmployeeAfterLeaveAnualUpdated
        "
        :employee="employee"
      />
    </a-drawer>
  </div>
</template>
<script>
import EditLeaveDay from "./editLeaveDay";
export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
    refreshEmployeeAfterLeaveAnualUpdated: {
      type: Function,
      required: true,
    },
  },
  components: { EditLeaveDay },
  data() {
    return {
      visibleEdit: false,
    };
  },
  computed: {
    isLeaveDayExist() {
      if (this.employee?.annualLeaveDay) {
        return true;
      }
      return false;
    },

    employeeShift() {
      return (
        this.employee?.workShift ||
        this.employee?.branchLocation?.mainShift ||
        {}
      );
    },
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
